import {
  analyticsService,
  apiService,
  ClientDeviceType,
  configureUserAgent,
  metricsService,
  SupportedOS,
  UserAgent,
} from "@blacknut/javascript-sdk/dist";
import { logD, logI } from "@blacknut/logging/dist";
import {
  DeprecatedStorageKey,
  mediationServerService,
  notificationsService,
  StorageKey,
} from "core";
import Cookies from "js-cookie";
import { setupDatadog } from "./datadog";
import "./i18n/i18n";
import "./index.css";
import electronService from "./services/ElectronService";
import localStorageService from "./services/LocalStorageService";
import { LOGGING_TAG } from "./utils/Utils";
//FIXME huge refactoring required with App.tsx
setupDatadog();

const setToLocalStorageIfDefined = (key: string, value: string | null | undefined) => {
  if (value) {
    localStorage.setItem(key, value);
  }
};

// Lang cookie used on web
const lang = Cookies.get("lang") || navigator.language || navigator["userLanguage"];
apiService.locale = lang;

//FIXME use constants defined in StorageKey
const qs = new URLSearchParams(window.location.search);
const _modelFromQuery = qs.get("model");
const _brandFromQuery = qs.get("brand");
const _deviceFromQuery = qs.get("device"); // careful also used in preview
const _osFromQuery = qs.get("os") as unknown as SupportedOS; // used on preview

localStorage.removeItem("device"); //https://blacknut-team.slack.com/archives/C04RFEAC8KE/p1743065706802289
localStorage.removeItem("model"); //https://blacknut-team.slack.com/archives/C04RFEAC8KE/p1743065706802289
localStorage.removeItem("brand"); //https://blacknut-team.slack.com/archives/C04RFEAC8KE/p1743065706802289

const deviceModel = _modelFromQuery || localStorage.getItem("model");
const deviceBrand = _brandFromQuery || localStorage.getItem("brand");
const deviceLayout = _deviceFromQuery || localStorage.getItem("device");

setToLocalStorageIfDefined("model", _modelFromQuery);
setToLocalStorageIfDefined("brand", _brandFromQuery);
setToLocalStorageIfDefined("device", _deviceFromQuery);

const appVersion = process.env.REACT_APP_CLIENT_VERSION || "0.0.0";

const userAgent: UserAgent = {
  ...configureUserAgent(),
  clientVersion: appVersion,
  flavor: process.env.REACT_APP_FLAVOR,
};

if (deviceLayout) {
  switch (deviceLayout.toLowerCase()) {
    case "tv":
      userAgent.client = ClientDeviceType.TV;
      userAgent.deviceType = "TV";
      break;
    case "tablet":
      userAgent.client = ClientDeviceType.TABLET;
      userAgent.deviceType = "TABLET";
      break;
    case "phone":
    case "mobile":
      userAgent.client = ClientDeviceType.PHONE;
      userAgent.deviceType = "MOBILE";
      break;
  }
} else if (electronService.isAvailable()) {
  userAgent.clientVersion = electronService.version;
  userAgent.client = ClientDeviceType.DESKTOP;
  userAgent.deviceType = "DESKTOP";
  // Data recovery from previous release of yoshi
  // Prior to 2.0.0 local storage values where not all JSON values, so get value directly from localstorage instead of using service
  const version = localStorage.getItem(StorageKey.VERSION);
  if (version) {
    logI(LOGGING_TAG, "Previous version ? %s", version);

    const re = /([0-9]+)\.([0-9]+)\.([0-9]+)/;
    const match = version.match(re);
    if (match) {
      if (parseInt(match[1], 10) < 2) {
        // Upgraded from yoshi
        const platform = localStorage.getItem(StorageKey.PLATFORM);
        logD(LOGGING_TAG, "GOT PLATFORM %s", platform);

        if (platform) {
          localStorage.setItem(StorageKey.PLATFORM, JSON.stringify(platform));
        }

        // Version prior to 1.8 token is a v4 token
        localStorage.removeItem(StorageKey.TOKEN);

        // From yoshi 1.8 famly token renamed to token
        const familyToken = localStorage.getItem(DeprecatedStorageKey.TOKEN);
        logD(LOGGING_TAG, "GOT FAMILY TOKEN %o", familyToken);
        localStorage.removeItem(DeprecatedStorageKey.TOKEN);
        if (familyToken) {
          localStorage.setItem(StorageKey.TOKEN, familyToken);
        }
      }
    }
  }
}
localStorageService.setItem(StorageKey.VERSION, appVersion);

if (deviceModel) userAgent.model = deviceModel;
if (deviceBrand) userAgent.brand = deviceBrand;
if (_osFromQuery) userAgent.os = _osFromQuery;

mediationServerService.lang = lang;
mediationServerService.userAgent(userAgent);

notificationsService.lang = lang;
notificationsService.userAgent(userAgent);

apiService.userAgent = userAgent;

///////////////////////////////////////
// Analytics
///////////////////////////////////////
analyticsService.userAgent = userAgent;
if (electronService.isAvailable()) {
  analyticsService.setApp("pc-client");
  electronService.getNetworkConnectionType().then((type) => {
    analyticsService.setConnectionType(type);
  });
} else {
  analyticsService.setApp("webapp");
  const nav = navigator as any;
  const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
  if (connection) {
    analyticsService.setConnectionType(connection.type);
  }
}
analyticsService.setAppGroup("webapp");

metricsService.userAgent = userAgent;
